var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "vs-slilder" },
    [
      _vm.isSlidable
        ? _c("VsProgressBar", {
            staticClass: "vs-slider__progress",
            attrs: { percentage: _vm.percentage }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        staticClass: "vs-slilder__input",
        class: [_vm.wide ? "wide" : "", _vm.minimized ? "minimized" : ""],
        attrs: { type: "range", min: _vm.min, max: _vm.max, step: _vm.step },
        domProps: { value: _vm.renderValue },
        on: { input: _vm.handleValue, change: _vm.handleValue }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }